module.exports = __webpack_public_path__ + "static/media/pt.2e1cc5e4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pt.svg
// module id = 2193
// module chunks = 0